import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { loc, levelLabel } from "@/lib/localize";

const LEVEL_COLORS = {
  Beginner: "bg-success/10 text-success",
  "Risk Management": "bg-danger/10 text-danger",
  "Trading Psychology": "bg-gold/15 text-[#8a6d2f]",
};

export function EducationCard({ lesson }) {
  const { isAr, L } = useLang();
  const tone = LEVEL_COLORS[lesson.level] || "bg-finblue/10 text-finblue";
  return (
    <Link
      to={`/education/${lesson.slug}`}
      className="group flex flex-col rounded-xl border border-hair bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
      data-testid={`education-card-${lesson.slug}`}
    >
      <div className="flex items-center justify-between">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-gold">
          <GraduationCap className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <span className={`rounded-md px-2 py-1 text-[11px] font-semibold ${tone}`}>{levelLabel(lesson.level, isAr)}</span>
      </div>
      <h3 className="mt-5 font-heading text-lg font-semibold text-ink">{loc(lesson, "title", isAr)}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-subtle">{loc(lesson, "excerpt", isAr)}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-finblue">
        {L.common.startLesson} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180" />
      </span>
    </Link>
  );
}
